import {
  handleChangeAllActionType,
  handleChangeToInitStateActionType,
} from "../../actions/handleChangeAction";

const INITIAL_STATE = {
  fraDato: "",
  tilDato: "",
  submitTimestamp: "",
};

export default function makuleringerSubmittedFormReducer(
  state = {
    ...INITIAL_STATE,
  },
  action,
) {
  switch (action.type) {
    case handleChangeAllActionType("RAPPORT_MAKULERINGER_SUBMITTED_FORM"):
      return { ...action.payload };
    case handleChangeToInitStateActionType(
      "RAPPORT_MAKULERINGER_SUBMITTED_FORM",
    ):
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
}
